// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingPanel_overlay__7K9-6","progress":"LoadingPanel_progress__GxxB+","spin":"LoadingPanel_spin__BGUlK"};